import React from 'react'

function Featured() {
  return (
    <div>
        <section id="tabs" class="tabs">
                <div class="container" data-aos="fade-up">

                <div class="section-title">
                    <h2>How Does Laser Scanning Works in Construction?</h2>
                    <p></p>
                </div>

                <ul class="nav nav-tabs row d-flex">
                    <li class="nav-item col-3">
                    <a class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab-1">
                        <i class="bi bi-file-bar-graph"></i>
                        <h4 class="d-none d-lg-block">Data Acquisition</h4>
                    </a>
                    </li>
                    <li class="nav-item col-3">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-2">
                        <i class="bi bi-file-earmark-arrow-down"></i>
                        <h4 class="d-none d-lg-block">Importing Data</h4>
                    </a>
                    </li>
                    <li class="nav-item col-3">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-3">
                        <i class="bi bi-building"></i>
                        <h4 class="d-none d-lg-block">BIM Modeling</h4>
                    </a>
                    </li>
                    <li class="nav-item col-3">
                    <a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab-4">
                        <i class="bi bi-bezier"></i>
                        <h4 class="d-none d-lg-block">Exporting</h4>
                    </a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane active show" id="tab-1">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0" data-aos="fade-up" data-aos-delay="100">
                        <h3>Data Acquisition</h3>
                        <p class="fst-italic" style={{textAlign:"justify"}}>
                            With the use of 3D laser scanners, precise point cloud data is gathered. Scanner provide quick scanning, accurate data, time savings, and steady support.
                        </p>
                        <ul style={{textAlign:"justify"}}>
                            <li><i class="ri-check-double-line"></i> 3D laser scanners excel in delivering precise and efficient data acquisition, capturing detailed spatial information with sub-millimeter accuracy and significantly reducing the time required for tasks like surveying and quality control.</li>
                            <li><i class="ri-check-double-line"></i> Their versatility spans various industries, including engineering, architecture, and forensics, making them indispensable for applications such as reverse engineering, as-built documentation, crime scene analysis, and cultural heritage preservation.</li>
                            <li><i class="ri-check-double-line"></i>Continuous technological advancements and steady support ensure that 3D laser scanning remains at the forefront of spatial data acquisition, integrating seamlessly with other technologies and offering users a reliable and evolving solution.</li>
                        </ul>
                        {/* <p>
                        With the use of 3D laser scanners, precise point cloud data is gathered. Scanner provide quick scanning, accurate data, time savings, and steady support.
                        </p> */}
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center" data-aos="fade-up" data-aos-delay="200">
                        <img src="assets/img/leo/1.jpg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    </div>
                    <div class="tab-pane" id="tab-2">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                        <h3>Importing Data</h3>
                        {/* <p>
                        The appropriate BIM software is used to import the gathered data and create models. Documentation becomes data-driven, rapid & secure, and simple to use, providing realistic results.
                        </p> */}
                        <p class="fst-italic" style={{textAlign:"justify"}}>
                            The appropriate BIM software is used to import the gathered data and create models. Documentation becomes data-driven, rapid & secure, and simple to use, providing realistic results.
                        </p>
                        <ul style={{textAlign:"justify"}}>
                            <li><i class="ri-check-double-line"></i> The utilization of BIM software streamlines the integration of collected data, enabling the swift creation of detailed models in a digital environment.</li>
                            <li><i class="ri-check-double-line"></i> With a focus on data-driven documentation, BIM software ensures that project records are not only comprehensive but also reflect the latest and most accurate information, promoting precision in design and construction.</li>
                            <li><i class="ri-check-double-line"></i> The user-friendly nature of BIM software enhances collaboration among stakeholders, making it straightforward to work with realistic 3D models, ultimately contributing to more efficient and secure project outcomes.</li>
                        </ul>
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                        <img src="assets/img/leo/2.jpg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    </div>
                    <div class="tab-pane" id="tab-3">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                        <h3>BIM Modeling</h3>
                        {/* <p>
                        The point cloud data is transformed using computer programs into an extensive BIM model. Construction delays are reduced and the design process moves more quickly by integrating 3D building scanning into the BIM model.
                        </p> */}
                        <p class="fst-italic" style={{textAlign:"justify"}}>
                             The point cloud data is transformed using computer programs into an extensive BIM model. Construction delays are reduced and the design process moves more quickly by integrating 3D building scanning into the BIM model.
                        </p>
                        <ul style={{textAlign:"justify"}}>
                            <li><i class="ri-check-double-line"></i>Computer programs play a vital role in converting point cloud data into a detailed Building Information Modeling (BIM) model, ensuring a comprehensive and accurate representation of the scanned environment.</li>
                            <li><i class="ri-check-double-line"></i> Integrating 3D building scanning into the BIM model reduces construction delays by facilitating informed decision-making, clash detection, and optimized workflows, thereby improving overall construction efficiency.</li>
                            <li><i class="ri-check-double-line"></i> The incorporation of 3D building scanning into the BIM model not only streamlines the design process but also provides designers with real-world context and precise measurements, contributing to more informed decision-making and better collaboration among project stakeholders.</li>
                        </ul>
                        
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                        <img src="assets/img/leo/7.jpg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    </div>
                    <div class="tab-pane" id="tab-4">
                    <div class="row">
                        <div class="col-lg-6 order-2 order-lg-1 mt-3 mt-lg-0">
                        <h3>Exporting</h3>
                        {/* <p>
                        Once complete, the 3D BIM model is delivered to the client in the required format. You can export survey data in a comprehensible manner
                        </p> */}
                        <p class="fst-italic" style={{textAlign:"justify"}}>
                            Once complete, the 3D BIM model is delivered to the client in the required format. You can export survey data in a comprehensible manner
                        </p>
                        <ul style={{textAlign:"justify"}}>
                            <li><i class="ri-check-double-line"></i> Upon completion, the 3D BIM model is meticulously exported to the client in their preferred format, ensuring compatibility with their specific software and project requirements.</li>
                            <li><i class="ri-check-double-line"></i> The export includes survey data presented in an easily understandable format, providing clients with a detailed and organized overview of the spatial elements captured during the modeling process.</li>
                            <li><i class="ri-check-double-line"></i> This client-tailored export not only facilitates efficient integration into the client's workflow but also ensures that the delivered 3D BIM model serves as a valuable and comprehensible asset for their ongoing and future project needs.</li>
                        </ul>
                        </div>
                        <div class="col-lg-6 order-1 order-lg-2 text-center">
                        <img src="assets/img/leo/4.jpg" alt="" class="img-fluid" />
                        </div>
                    </div>
                    </div>
                </div>

                </div>
            </section>
    </div>
  )
}

export default Featured